import { api } from './client';
import type { Kingdom } from '../types/kingdom';

interface GetKingdomResult {
  kingdom: Kingdom | null;
  error: string | null;
}

export async function getKingdom(worldId: string, kingdomId: string): Promise<GetKingdomResult> {
  const response = await api.get<Kingdom>(`/api/worlds/${worldId}/kingdoms/${kingdomId}`);
  return {
    kingdom: response.data,
    error: response.error,
  };
}

interface RandomKingdomResult {
  kingdomId: string;
}

export async function getRandomKingdom(worldId: string): Promise<RandomKingdomResult> {
  const response = await api.get<RandomKingdomResult>(`/api/worlds/${worldId}/kingdoms/random`);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data!;
}
